










import Vue from "vue";
import ForgetPassword from "@/components/templates/ForgetPassword/index.vue";
import { Auth } from "aws-amplify";
import snackbar from "@/shared/snackbar";

export default Vue.extend({
  components: { ForgetPassword },
  data() {
    return {
      forgotPasswrodRequestIsDone: false,
      username: "",
    };
  },
  methods: {
    forgotPassword(username: string) {
      this.username = username;
      this.$store.dispatch("app/startRequest");
      Auth.forgotPassword(username)
      .then((data) => {
        this.forgotPasswrodRequestIsDone = true;
        this.$store.dispatch("app/endRequest");
        snackbar.success(this, { message: `登録されたメールアドレスに宛に認証コードを送信しました。` });
      })
      .catch((err) => {
        // To hide whether the name inputted by user exist or not,
        // all result would be lead to the same one.
        this.$store.dispatch("app/endRequest");
        if (err.code === "LimitExceededException") {
          snackbar.success(this, { message: `認証コードが送信できませんでした: ${err.message}` });
        } else {
          this.forgotPasswrodRequestIsDone = true;
          snackbar.success(this, { message: `登録されたメールアドレスに宛に認証コードを送信しました。` });
        }
      });
    },
    resendAuthCode() {
      if (!this.username) {
        alert("不正な操作です。ログイン画面に戻ります");
        this.goLogin();
        return;
      }
      this.forgotPassword(this.username);
    },
    async resetPassword(credential: any) {
      console.log(credential);
      try {
        this.$store.dispatch("app/startRequest");
        const data = await Auth.forgotPasswordSubmit(
          this.username,
          credential.authCode,
          credential.newPassword);
        this.$store.dispatch("app/endRequest");
        snackbar.success(this, { message: `パスワードを変更しました。` });
        this.goLogin();
      } catch (err) {
        this.$store.dispatch("app/endRequest");
        snackbar.error(this, { message: err.message });
      }
    },
    goLogin() {
      this.$router.push("/login");
    },
  },
});
